module.exports = __webpack_public_path__ + "img/parter-work8.ccc93ecc.png";